import React, { ReactChildren, useRef } from "react";
import { Box, Card, CardBody, CardFooter, CardHeader, Image, Text, Tip } from "grommet";
import { ImageTypes, ContentViewModel, EntityTypes } from "./ContentStore";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import ParallaxTilt2 from "../components/ParallaxTilt2";

export const ContentCard = ({ content, width, onClick }: { content: ContentViewModel; width?: number; onClick: any }) => {
    return (
        <>
            {/* // <ParallaxTilt2> */}
            {/* <Link to={`/content/${content.id}`} style={{ textDecoration: "none" }}> */}
            <Card width={!!width ? width + "px" : "250px"} height={!!width ? width * 1.5 + "px" : "375px"} background="background" onClick={onClick}>
                <CardBody align="center" justify="center">
                    <Box align="center">
                        <Image src={content.thumbURI} fit="contain" />
                    </Box>
                </CardBody>
                <CardHeader pad="small" justify="center" fill="horizontal">
                    <Text textAlign="center">{content.name}</Text>
                </CardHeader>
                <CardFooter pad="small" background="background-front">
                    <Box direction="row" gap="small" fill="horizontal">
                        {(content.allowedTypes & ImageTypes.Logo) == ImageTypes.Logo && (
                            <Tip content="Logo">
                                <Box>
                                    <FontAwesomeIcon icon={["fad", "image-portrait"]} />
                                </Box>
                            </Tip>
                        )}
                        {(content.allowedTypes & ImageTypes.Splash) == ImageTypes.Splash && (
                            <Tip content="Splash">
                                <Box>
                                    <FontAwesomeIcon icon={["fad", "image-landscape"]} />
                                </Box>
                            </Tip>
                        )}

                        {(content.allowedEntities & EntityTypes.Alias) == EntityTypes.Alias && (
                            <Tip content="Alias">
                                <Box>
                                    <FontAwesomeIcon icon={["fad", "user"]} />
                                </Box>
                            </Tip>
                        )}
                        {(content.allowedEntities & EntityTypes.Team) == EntityTypes.Team && (
                            <Tip content="Team">
                                <Box>
                                    <FontAwesomeIcon icon={["fad", "users"]} />
                                </Box>
                            </Tip>
                        )}
                        {(content.allowedEntities & EntityTypes.Match) == EntityTypes.Match && (
                            <Tip content="Match">
                                <Box>
                                    <FontAwesomeIcon icon={["fad", "swords"]} />
                                </Box>
                            </Tip>
                        )}
                        {(content.allowedEntities & EntityTypes.Tournament) == EntityTypes.Tournament && (
                            <Tip content="Tournament">
                                <Box>
                                    <FontAwesomeIcon icon={["fad", "trophy"]} />
                                </Box>
                            </Tip>
                        )}
                        {(content.allowedEntities & EntityTypes.League) == EntityTypes.League && (
                            <Tip content="League">
                                <Box>
                                    <FontAwesomeIcon icon={["fad", "trophy-star"]} />
                                </Box>
                            </Tip>
                        )}
                        {(content.allowedEntities & EntityTypes.Season) == EntityTypes.Season && (
                            <Tip content="Season">
                                <Box>
                                    <FontAwesomeIcon icon={["fad", "calendar-range"]} />
                                </Box>
                            </Tip>
                        )}
                        {(content.allowedEntities & EntityTypes.Badge) == EntityTypes.Badge && (
                            <Tip content="Badge">
                                <Box>
                                    <FontAwesomeIcon icon={["fad", "shield"]} />
                                </Box>
                            </Tip>
                        )}
                        {(content.allowedEntities & EntityTypes.Map) == EntityTypes.Map && (
                            <Tip content="Map">
                                <Box>
                                    <FontAwesomeIcon icon={["fad", "map"]} />
                                </Box>
                            </Tip>
                        )}
                    </Box>
                </CardFooter>
            </Card>
            {/* </Link> */}
            {/* // </ParallaxTilt2> */}
        </>
    );
};
